import { render, staticRenderFns } from "./ViewHospital.vue?vue&type=template&id=5a3dd40e&scoped=true&"
import script from "./ViewHospital.vue?vue&type=script&lang=js&"
export * from "./ViewHospital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3dd40e",
  null
  
)

export default component.exports